import Popup from "../../../../shared/Popup";
import {useEffect, useState} from "react";
import 'rsuite/Tooltip/styles/index.css';
import Toaster from "../../../../shared/Toaster";
import {ToasterProps} from "../../../../shared/Toaster/Toaster";
import Loader from "rsuite/Loader";
import ReceiveBlock from "./components/ReceiveBlock/ReceiveBlock";
import DepositButton from "./components/DepositButton/DepositButton";
import FastButtonsBlock from "./components/FastButtonsBlock/FastButtonsBlock";
import SetAmountDeposit from "./components/SetAmountDeposit/SetAmountDeposit";
import DepositMethod from "./components/DepositMehod/DepositMethod";
import {createPayment} from "./components/createPayment";
import {calcBonus} from "./components/calcBonus";
import EmailBlock from "./components/EmailBlock/EmailBlock";

const PopupDeposit = (props) => {
    const { methodPayment, activePopup, setActivePopup, setActivePopupNotFully, user,
        amountDeposit, setAmountDeposit, rateCurrency} = props
    const [ emailPlaceholder, setEmailPlaceholder ] = useState("")
    const [ email, setEmail ] = useState(user?.email)
    const [toastProps, setToastProps] = useState<ToasterProps | null>(null);
    const [onBlurLoad, setOnBlurLoad] = useState(false);
    const [ bonusLine, setBonusLine] = useState(0);

    let accrualAmount;
    let accrualAmountSum;
    let minSumForBonus;

    ({ accrualAmount = 0, accrualAmountSum = 0, minSumForBonus = 3000 } = calcBonus({
        amountDeposit,
        methodPayment,
        rateCurrency,
        minSumForBonus,
        user,
        accrualAmount,
        accrualAmountSum
    }));

    useEffect(() => {
        setEmailPlaceholder(user.email)
        setAmountDeposit(methodPayment?.buttonsData[0].sum)
    }, [methodPayment])

    return (
        <Popup title={"Поповнення"} activePopup={activePopup} setActivePopup={setActivePopup}>
            <div style={onBlurLoad ? {filter: "saturate(90%) blur(7px)"}: {}}>
                <EmailBlock
                    email={email}
                    setEmail={setEmail}
                    emailPlaceholder={emailPlaceholder}
                    user={user}
                />
                <div className="payment-method-wrapper">
                    <DepositMethod methodPayment={methodPayment} />
                    <SetAmountDeposit
                        setAmountDeposit={setAmountDeposit}
                        amountDeposit={amountDeposit}
                        accrualAmount={accrualAmount}
                        methodPayment={methodPayment}
                    />
                    <FastButtonsBlock
                        bonusLine={bonusLine}
                        methodPayment={methodPayment}
                        setAmountDeposit={setAmountDeposit}
                        amountDeposit={amountDeposit}
                        setBonusLine={setBonusLine}
                        rateCurrency={rateCurrency}
                    />
                    <ReceiveBlock accrualAmountSum={accrualAmountSum} bonusLine={bonusLine} />
                    <DepositButton createPayment={ () => createPayment(
                        amountDeposit,
                        methodPayment,
                        setToastProps,
                        setActivePopup,
                        setActivePopupNotFully,
                        email, setEmail, user,
                        emailPlaceholder, setOnBlurLoad)
                    } amountDeposit={amountDeposit} methodPayment={methodPayment} email={email} />
                </div>
                {toastProps && <Toaster message={toastProps.message} type={toastProps.type} id={toastProps.id} />}
            </div>
            {onBlurLoad && <Loader size="lg" backdrop />}
        </Popup>
    );
};

export default PopupDeposit;